import React from 'react';
import "../styles/index.css"
import card_video from "../img/chai-background.mp4"
import logo_skeleton from "../img/pyaali-skeleton-white.png"


const Home = () => {
	return (

	<div>
		<video autoPlay loop muted playsInline className="card-video">
			<source src={card_video} type="video/mp4" />
		</video>

		<div className="main-body">	
			<img className="logo-white"  src={logo_skeleton} alt="Logo"></img>
		</div>
	</div>
		
	);
};

export default Home;
